<template>
  <base-warning v-model="modelValue">
    <div class="d-flex flex-column gap-1">
      <p>
        A dose deve ser prescrita de acordo com o peso do paciente e o nível sérico de IgE medido antes do início do
        tratamento. As doses estão nas Tabelas 1 e 2 abaixo. <br />
        Para saber quantas seringas de 75 mg e 150 mg aplicar, veja a Tabela 3.
      </p>
      <figure>
        <img src="/assets/attendance-form/medicine-prescription/omalizumab/table-1.png" alt="" />
        <figcaption>Tabela 1 - Dose de Omalizumabe administrada por injeção subcutânea a cada 4 semanas.</figcaption>
      </figure>
      <figure>
        <img src="/assets/attendance-form/medicine-prescription/omalizumab/table-2.png" alt="" />
        <figcaption>Tabela 2 - Dose de Omalizumabe administrada por injeção subcutânea a cada 2 semanas.</figcaption>
      </figure>
      <figure>
        <img src="/assets/attendance-form/medicine-prescription/omalizumab/table-3.png" alt="" />
        <figcaption>
          Tabela 3 - Conversão de dose para número de seringas preenchidas, número de injeções e volume total de injeção
          para cada administração.
        </figcaption>
      </figure>

      <p>Atenção</p>
      <p>
        Para solicitar esse medicamento <span class="font-weight-bold"> via SUS </span>, atente-se para às seguintes
        exigências:
      </p>
      <ul>
        <li><span class="font-weight-bold">Espirometria</span>;</li>
        <li>
          <span class="font-weight-bold"> Teste alérgico </span> cutâneo ou dosagem de
          <span class="font-weight-bold"> IgE específica </span>;
        </li>
        <li><span class="font-weight-bold"> Dosagem de IgE sérica total </span>;</li>
        <li>
          Relatório médico / anamnese constando informação de pelo menos,
          <span class="font-weight-bold"> uma exacerbação grave </span> no ano anterior com necessidade de curso de
          corticoide oral.
        </li>
      </ul>

      <p>
        Para solicitar esse medicamento via <span class="font-weight-bold">OPERADORA DE SAÚDE</span>, atente-se para às
        seguintes exigências:
      </p>

      <div v-html="asthmaRequirements['asma-alergica-grave']" />
    </div>
  </base-warning>
</template>

<script>
import { ComputedOptions } from 'vue'
import BaseWarning from '../BaseWarning.vue'
import asthmaRequirements from './helper/commonRequirements'

export default {
  components: { BaseWarning },
  name: 'ConductWarning.Omalizumabe75',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      asthmaRequirements,
    }
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
